// TODO: Change CartSelectionItem to CartSelection when server is ready
import { CartSelection, CartSelectionItem, Model } from '@datamodel';

export class Suggestion extends Model {
    static get model() {
        return {
            id: '',
            selections: [],
            removedSelections: [],
            title: '',
            description: ''
        }
    }

    static get keymap() {
        return {
            suggested_product_selections: 'selections',
            removed_product_selections: 'removedSelections'
        }
    }

    static get parseMap() {
        return {
            selections: selections => selections.map(s => CartSelectionItem.parse(s)),
            removedSelections: removedSelections => removedSelections.map(s => CartSelectionItem.parse(s))
        }
    }

    static get parseCallback() {
        return (parsed) => {
            const suggestion = { ...parsed };

            // TODO: Use CartSelection, for now create a new one with given item.
            suggestion.selections = suggestion.selections.map(s => CartSelection.addSelectionId({
                ...CartSelection.model,
                item: s
            }));

            return suggestion;
        }
    }

}
